import chevronLeft24White from 'images/icons/chevron-left-24_white.svg';
import close16White from 'images/icons/close-16_white.svg';
import React, { ReactElement } from 'react';

interface Props {
  title: string;
  showBackArrow: boolean;
  onBack?: () => void;
  onClose: () => void;
}

const PopoverHeader = (props: Props): ReactElement => {
  const { title, showBackArrow, onBack, onClose } = props;

  return (
    <div className="row justify-between items-center hs3 pl4 pr2 bb-2 bgd-primary-blue">
      <div className="row items-center">
        {showBackArrow ? (
          <div
            className="mr3 wrem-1p5 cursor-pointer"
            style={{ marginLeft: '-8px' }}
            onClick={onBack}
          >
            <img
              id="popover-header-back-button"
              src={chevronLeft24White}
              alt="back arrow"
            />
          </div>
        ) : null}
        <div className="bold white-2 font-size-4 medium">{title}</div>
      </div>
      <button
        id="popover-header-close-button"
        className="cursor-pointer btn-primary btn-xs"
        style={{ padding: 0 }}
        onClick={onClose}
      >
        <img src={close16White} alt="close drawings filter popover" />
      </button>
    </div>
  );
};

export default PopoverHeader;
